<template>
	<div
		class="wrapper" @click="toggleCheck"
		:class="{ 'disabled-item': reserve.permission_action == 0 || reserve.permission_action == false }"
	>
		<div class="reference" :style="unityClass">
			{{ reserve.reference }}
		</div>

		<div class="info">
			<div class="info title">{{ reserve.title }}</div>
			<div class="info description">
				<small>{{ reserve.description }} {{ reserve.cost ? '- R$ ' + formatPrice(reserve.cost) : '' }}</small>
			</div>
		</div>

		<div v-if="!(reserve.permission_action == 0 || reserve.permission_action == false)" class="circle-check" :class="checkboxClass">
			<em v-show="check" class="fal fa-check"></em>
		</div>
	</div>
</template>

<script>
	import helpers from '@/mixins/helpers'

	export default {
		name: 'reserve-wrapper-item',

		props: {
			value: {
				type: String,
				required: true,
			},

			checked: {
				type: Boolean,
				required: true,
			},

			reserve: {
				type: Object,
				required: true,
			},
		},

		mixins: [helpers],

		data() {
			return {
				check: false,
			}
		},

		methods: {
			unitySituation(reserve) {
				switch (reserve.situation) {
					case 'available':
						return '#00CC98'
					case 'reserved':
						return '#FFCA9F'
					case 'pre-reserve':
						return '#FB8120'
					case 'reserved-permanetly':
						return '#939393'
					case 'sale':
						return '#ff081c'
					case 'unavailable':
						return '#9B59B6'
					case 'canceled':
						return '#5e5eff'
					default:
						return '#400000'
				}
			},

			toggleCheck() {
				const currentData = `${this.reserve.id} ${this.reserve.description}`
				this.$emit('input', currentData)
			},
		},

		computed: {
			checkboxClass() {
				return {
					active: this.check,
				}
			},

			unityClass() {
				return !this.check
					? {
							border: '2px solid ' + this.unitySituation(this.reserve),
							color: this.unitySituation(this.reserve),
					  }
					: {
							background: this.unitySituation(this.reserve),
							color: "#FFF",
					  }
			},
		},

		watch: {
			checked(value) {
				this.check = value
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
